import React from 'react'
import ServiceDescription from '../elements/ServiceDescription'

const ServicesSection = () => {
  return (
    <section id="services" className="services section">

      <div className="container section-title" data-aos="fade-up">
        <h2>Servicios</h2>
        <p>
          Ofrecemos los siguientes servicios:
        </p>
      </div>

      <div className="container">
        <div className="row gy-4">

          <ServiceDescription
            icon="bi bi-binoculars"
            title="Landing page"
            description="Trabajamos contigo desde el diseño hasta la implementación, garantizando que tu página cumpla con tus objetivos de negocio."
          />

          <ServiceDescription
            icon="bi bi-briefcase"
            title="Proyectos personalizados"
            description="Desde una tienda en línea hasta un sistema de gestión, transformamos tus ideas en soluciones funcionales que impulsan tu negocio."
          />

          <ServiceDescription
            icon="bi bi-card-checklist"
            title="Desarrollo funcional"
            description="Este servicio es perfecto para empresas que buscan mantener sus soluciones al día sin necesidad de comenzar desde cero."
          />
        </div>
      </div>
    </section>
  )
}

export default ServicesSection